import { Hero } from "@/components/Hero";
import { ProblemSolution } from "@/components/ProblemSolution";
import { USP } from "@/components/USP";
import { Trainers } from "@/components/Trainers";
import { Benefits } from "@/components/Benefits";
import { Programs } from "@/components/Programs";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <Hero />
      <div className="px-4 sm:px-6 lg:px-8">
        <ProblemSolution />
        <USP />
        <Benefits />
        <Programs />
        <Trainers />
        <Testimonials />
        <FAQ />
      </div>
      <Footer />
    </div>
  );
};

export default Index;
